<template>
  <div>
      <Cbarra>
        <template slot="slotTitle">Calendario</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'icalendario'}">Calendario</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal-02">
            <div class="row">
                <!-- <button  role="button"  @click="get_Eventos" class="btn form-control" ></button> -->
                <template v-for="(item, index) in events">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="(item.value.length>0)" :key="index">
                        <h6 class="color8 sobra-texto big">{{verificarMes(item.mes)}} <span class="color_Azul">2021</span></h6>
                        <div class="card w-100 card-calendar">
                            <div class="card-body row" >
                                <template v-for="(item2, index2) in item.value">
                                    <!-- <div v-if="index2 < item.limit" class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 bg-05" :style="'background-color:'+item2.Color">
                                        <div class="centrar_div" data-toggle="modal" data-target="#exampleModal" onclick="loadDoc('evento_01.html');">
                                            <h3>{{Verificarnumero(item2.mes)+'.'+item2.dia}}</h3>
                                            <p>
                                                {{item2.Titulo}}
                                            </p>
                                        </div>
                                    </div> -->
                                     <eventos v-if="index2 < item.limit" :value="item2" :rutafile="RutaFileEvento" :anio="anio" :key="index2"></eventos>
                                </template>

                                <mas v-if="item.total > 11 && item.limit < item.total" :value="item" :mes="verificarMes(item.mes)"></mas>

                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import mas from './components/cargarmas.vue'
import eventos from './components/eventos.vue'

export default {
    components:{
        mas,
        eventos
    },
    data() {
        return {
            events:[],
            RutaFileEvento:'',
            anio:'',
            meses: [
                { value: 1, label: "Enero" },
                { value: 2, label: "Febrero" },
                { value: 3, label: "Marzo" },
                { value: 4, label: "Abril" },
                { value: 5, label: "Mayo" },
                { value: 6, label: "Junio" },
                { value: 7, label: "Julio" },
                { value: 8, label: "Agosto" },
                { value: 9, label: "Septiembre" },
                { value: 10, label: "Octubre" },
                { value: 11, label: "Noviembre" },
                { value: 12, label: "Diciembre" },
            ],
        }
    },
    mounted() {
        this.get_Eventos();
    },
    methods: {
        Cargar(){
            /*console.log('Pasa');*/
        },
        get_Eventos(){
            this.$http.get(
                'inicio/eventosm/',
                {
                    params:{ RegEstatus:'A',Entrada:100}
                }
            ).then( (res) => {
                this.events = res.data.eventos;
                this.RutaFileEvento = res.data.RutaFile;
                this.anio = res.data.Anio;
            });
        },
        Verificarnumero(value){
            if(value < 10)
                return '0'+value;
            return value
        },
        verificarMes(mes) {
            let findedMes = this.meses.find( item => item.value == mes );
            return findedMes.label;
        },
    },
}
</script>